export default "__VITE_ASSET__8923210e__"